module.exports = __webpack_public_path__ + "static/media/zoom.5f984cbd.png";